import { render, staticRenderFns } from "./TabellaRichieste.vue?vue&type=template&id=6bbaf1dd&scoped=true&"
import script from "./TabellaRichieste.vue?vue&type=script&lang=js&"
export * from "./TabellaRichieste.vue?vue&type=script&lang=js&"
import style0 from "./TabellaRichieste.vue?vue&type=style&index=0&id=6bbaf1dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbaf1dd",
  null
  
)

export default component.exports